import { Initialize } from "@warda/library-ui/interfaces";
export var ACTION;
(function (ACTION) {
    ACTION["INIT_WAIT"] = "INIT_WAIT";
    ACTION["INIT_SUCC"] = "INIT_SUCC";
    ACTION["INIT_FAIL"] = "INIT_FAIL";
    ACTION["SEARCH"] = "SEARCH";
})(ACTION || (ACTION = {}));
export const reducerInitState = {
    initialize: Initialize.START,
    error: "",
    optionsInput: "",
    optionsItems: [],
    optionsTotal: 0,
};
const reducer = (state, action) => {
    const newState = { ...state };
    switch (action.type) {
        case ACTION.INIT_WAIT:
            newState.initialize = Initialize.WAIT;
            return newState;
        case ACTION.INIT_SUCC:
            newState.initialize = Initialize.SUCC;
            newState.optionsItems = action.items;
            newState.optionsTotal = action.total;
            return newState;
        case ACTION.INIT_FAIL:
            newState.initialize = Initialize.FAIL;
            newState.optionsItems = reducerInitState.optionsItems;
            newState.optionsTotal = reducerInitState.optionsTotal;
            newState.error = action.error;
            return newState;
        case ACTION.SEARCH:
            newState.initialize = Initialize.START;
            newState.optionsInput = action.input;
            newState.optionsItems = reducerInitState.optionsItems;
            newState.optionsTotal = reducerInitState.optionsTotal;
            return newState;
        default:
            return state;
    }
};
export default reducer;
